/*
  Petite Cabane — JavaScript mínimo del tema.
  Funciones nativas Shopify preferidas. Sin frameworks externos.
  Cubre: header al scroll, menú mobile (drawer), cart drawer,
  WhatsApp flotante, revelado al scroll y respeto a prefers-reduced-motion.
*/
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Header: comprime y difumina al hacer scroll ---------- */
  var header = document.querySelector("[data-header]");
  if (header) {
    var onScroll = function () {
      var scrolled = window.scrollY > 8;
      header.classList.toggle("is-scrolled", scrolled);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- Utilidad de drawer accesible (foco atrapado + Esc) ---------- */
  function Drawer(el) {
    this.el = el;
    this.panel = el.querySelector("[data-drawer-panel]");
    this.lastFocused = null;
    this.onKeydown = this.onKeydown.bind(this);
  }
  Drawer.prototype.open = function () {
    this.lastFocused = document.activeElement;
    this.el.classList.add("is-open");
    this.el.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", this.onKeydown);
    var focusable = this.getFocusable();
    if (focusable.length) focusable[0].focus();
  };
  Drawer.prototype.close = function () {
    this.el.classList.remove("is-open");
    this.el.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    document.removeEventListener("keydown", this.onKeydown);
    if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
  };
  Drawer.prototype.getFocusable = function () {
    return Array.prototype.slice.call(
      this.el.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (n) { return n.offsetParent !== null; });
  };
  Drawer.prototype.onKeydown = function (e) {
    if (e.key === "Escape") { this.close(); return; }
    if (e.key !== "Tab") return;
    var f = this.getFocusable();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  function wireDrawer(drawerEl) {
    if (!drawerEl) return null;
    var drawer = new Drawer(drawerEl);
    drawerEl.querySelectorAll("[data-drawer-close]").forEach(function (btn) {
      btn.addEventListener("click", function () { drawer.close(); });
    });
    var overlay = drawerEl.querySelector("[data-drawer-overlay]");
    if (overlay) overlay.addEventListener("click", function () { drawer.close(); });
    return drawer;
  }

  /* Menú mobile */
  var menuDrawer = wireDrawer(document.querySelector("[data-menu-drawer]"));
  document.querySelectorAll("[data-menu-open]").forEach(function (btn) {
    if (menuDrawer) btn.addEventListener("click", function () { menuDrawer.open(); });
  });

  /* Cart drawer */
  var cartDrawer = wireDrawer(document.querySelector("[data-cart-drawer]"));
  document.querySelectorAll("[data-cart-open]").forEach(function (btn) {
    if (!cartDrawer) return;
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      cartDrawer.open();
    });
  });

  /* ---------- WhatsApp flotante: aparece tras 200px de scroll ---------- */
  var wa = document.querySelector("[data-whatsapp-float]");
  if (wa) {
    var toggleWa = function () { wa.classList.toggle("is-visible", window.scrollY > 200); };
    toggleWa();
    window.addEventListener("scroll", toggleWa, { passive: true });
  }

  /* ---------- Galería de producto: miniaturas cambian la imagen principal ---------- */
  document.querySelectorAll("[data-gallery]").forEach(function (g) {
    var main = g.querySelector("[data-gallery-main]");
    var thumbs = g.querySelectorAll("[data-gallery-thumb]");
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        if (main) main.src = t.getAttribute("data-full");
        thumbs.forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });
  });

  /* ---------- Revelado al scroll: reveal + stagger + cortina de medios ---------- */
  var revealEls = document.querySelectorAll(".reveal, .stagger, .reveal-media");
  if (revealEls.length) {
    if (reduceMotion || !("IntersectionObserver" in window)) {
      revealEls.forEach(function (el) { el.classList.add("is-visible"); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el.classList.contains("stagger")) {
            var kids = el.children;
            for (var i = 0; i < kids.length; i++) {
              kids[i].style.transitionDelay = (i * 0.13) + "s";
            }
          }
          el.classList.add("is-visible");
          io.unobserve(el);
        });
      }, { rootMargin: "0px 0px -18% 0px", threshold: 0 });
      revealEls.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---------- Hero: parallax + fade del texto (el zoom lo hace el Ken Burns CSS) ---------- */
  if (!reduceMotion) {
    var heroSection = document.querySelector(".hero");
    var heroBox = heroSection ? heroSection.querySelector(".hero__box") : null;
    if (heroSection && heroBox) {
      var heroTicking = false;
      var onHeroScroll = function () {
        if (heroTicking) return;
        heroTicking = true;
        window.requestAnimationFrame(function () {
          var rect = heroSection.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            var progress = Math.min(Math.max(-rect.top / rect.height, 0), 1);
            heroBox.style.transform = "translateY(" + (-progress * 120) + "px)";
            heroBox.style.opacity = String(1 - progress * 0.95);
          }
          heroTicking = false;
        });
      };
      onHeroScroll();
      window.addEventListener("scroll", onHeroScroll, { passive: true });
    }

    /* ---------- Parallax genérico de capas de fondo (bandas cinematográficas) ---------- */
    var parallaxEls = document.querySelectorAll("[data-parallax]");
    if (parallaxEls.length) {
      var pTicking = false;
      var onParallax = function () {
        if (pTicking) return;
        pTicking = true;
        window.requestAnimationFrame(function () {
          for (var i = 0; i < parallaxEls.length; i++) {
            var el = parallaxEls[i];
            var wrap = el.parentElement;
            var r = wrap.getBoundingClientRect();
            if (r.bottom > 0 && r.top < window.innerHeight) {
              var center = (r.top + r.height / 2) - window.innerHeight / 2;
              var speed = parseFloat(el.getAttribute("data-parallax")) || 0.15;
              el.style.transform = "translate3d(0," + (-center * speed) + "px,0)";
            }
          }
          pTicking = false;
        });
      };
      onParallax();
      window.addEventListener("scroll", onParallax, { passive: true });
      window.addEventListener("resize", onParallax);
    }
  }

  /* ---------- Popup de anuncio ---------- */
  var popup = document.querySelector("[data-popup]");
  if (popup) {
    var enEditor = !!(window.Shopify && window.Shopify.designMode);
    var clave = popup.getAttribute("data-clave");
    var frecuencia = parseInt(popup.getAttribute("data-frecuencia"), 10) || 0;
    var retraso = parseInt(popup.getAttribute("data-retraso"), 10) || 0;
    var focoPrevio = null;

    /* localStorage puede lanzar en modo privado: nunca debe romper la página. */
    var leer = function (k) {
      try { return window.localStorage.getItem(k); } catch (e) { return null; }
    };
    var escribir = function (k, v) {
      try { window.localStorage.setItem(k, v); } catch (e) { /* sin persistencia */ }
    };

    var yaVisto = function () {
      if (enEditor || frecuencia === 0) return false;
      var marca = parseInt(leer(clave), 10);
      if (!marca) return false;
      var dias = (new Date().getTime() - marca) / 86400000;
      return dias < frecuencia;
    };

    var focoDentro = function () {
      return Array.prototype.slice.call(popup.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(function (n) { return n.offsetParent !== null; });
    };

    var alTeclado = function (e) {
      if (e.key === "Escape") { cerrar(); return; }
      if (e.key !== "Tab") return;
      var f = focoDentro();
      if (!f.length) return;
      var primero = f[0], ultimo = f[f.length - 1];
      if (e.shiftKey && document.activeElement === primero) {
        e.preventDefault(); ultimo.focus();
      } else if (!e.shiftKey && document.activeElement === ultimo) {
        e.preventDefault(); primero.focus();
      }
    };

    function abrir() {
      focoPrevio = document.activeElement;
      popup.hidden = false;
      popup.setAttribute("aria-hidden", "false");
      /* Un frame para que la transición de entrada se vea. */
      window.requestAnimationFrame(function () {
        popup.classList.add("is-open");
      });
      document.body.style.overflow = "hidden";
      document.addEventListener("keydown", alTeclado);
      var f = focoDentro();
      if (f.length) f[0].focus();
    }

    function cerrar() {
      popup.classList.remove("is-open");
      popup.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      document.removeEventListener("keydown", alTeclado);
      escribir(clave, String(new Date().getTime()));
      window.setTimeout(function () { popup.hidden = true; }, reduceMotion ? 0 : 220);
      if (focoPrevio && focoPrevio.focus) focoPrevio.focus();
    }

    popup.querySelectorAll("[data-popup-cerrar]").forEach(function (b) {
      b.addEventListener("click", cerrar);
    });
    var fondo = popup.querySelector("[data-popup-fondo]");
    if (fondo) fondo.addEventListener("click", cerrar);
    /* Si hace clic en el CTA, cuenta como visto y no vuelve a molestar. */
    var cta = popup.querySelector("[data-popup-cta]");
    if (cta) cta.addEventListener("click", function () {
      escribir(clave, String(new Date().getTime()));
    });

    if (!yaVisto()) {
      if (enEditor) abrir();
      else window.setTimeout(abrir, retraso);
    }
  }

  /* ---------- PDP: precio según medida + tela, y color como propiedad ---------- */
  var productForm = document.querySelector("[data-product-form]");
  var variantData = document.querySelector("[data-variant-data]");

  if (productForm && variantData) {
    var variants = [];
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (e) {
      variants = [];
    }

    var selects = productForm.querySelectorAll("[data-option-select]");
    var variantIdInput = productForm.querySelector("[data-variant-id]");
    var addButton = productForm.querySelector("[data-add-button]");
    var unavailableMsg = productForm.querySelector("[data-unavailable]");
    var priceNow = document.querySelector("[data-price-now]");
    var priceWas = document.querySelector("[data-price-was]");
    var priceBadge = document.querySelector("[data-price-badge]");
    var addButtonLabel = addButton ? addButton.textContent.trim() : "Agregar al carro";

    var currentSelection = function () {
      var values = [];
      for (var i = 0; i < selects.length; i++) {
        values[parseInt(selects[i].getAttribute("data-option-index"), 10)] = selects[i].value;
      }
      return values;
    };

    var findVariant = function (values) {
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options;
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (opts[j] !== values[j]) {
            match = false;
            break;
          }
        }
        if (match) return variants[i];
      }
      return null;
    };

    /* Marca las telas que no existen para la medida elegida (el catálogo a
       pedido no cubre toda la matriz medida x tela). */
    var flagImpossible = function () {
      var values = currentSelection();
      for (var i = 0; i < selects.length; i++) {
        var select = selects[i];
        var index = parseInt(select.getAttribute("data-option-index"), 10);
        var options = select.options;
        for (var k = 0; k < options.length; k++) {
          var probe = values.slice();
          probe[index] = options[k].value;
          var found = findVariant(probe);
          var label = options[k].getAttribute("data-label");
          if (!label) {
            label = options[k].textContent.replace(" — a cotizar", "");
            options[k].setAttribute("data-label", label);
          }
          options[k].textContent = found ? label : label + " — a cotizar";
        }
      }
    };

    /* El valor de "Tela" es un nivel de precio que puede agrupar varias telas
       ("Lino sintético, felpa o velvet"). Se reparte en el selector de tela
       exacta, que no afecta el precio. */
    var fabricPicker = productForm.querySelector("[data-fabric-picker]");
    var fabricSelect = productForm.querySelector("[data-fabric-select]");
    var tierSelect = productForm.querySelector('[data-option-name="Tela"]');

    var syncFabrics = function () {
      if (!fabricPicker || !fabricSelect || !tierSelect) return;

      var telas = tierSelect.value.split(" o ").join(", ").split(", ");
      var previo = fabricSelect.value;

      fabricSelect.innerHTML = "";
      for (var i = 0; i < telas.length; i++) {
        var etiqueta = telas[i].charAt(0).toUpperCase() + telas[i].slice(1);
        var opt = document.createElement("option");
        opt.value = etiqueta;
        opt.textContent = etiqueta;
        fabricSelect.appendChild(opt);
      }
      /* Conserva la tela elegida si sigue disponible en el nuevo nivel. */
      for (var k = 0; k < fabricSelect.options.length; k++) {
        if (fabricSelect.options[k].value === previo) {
          fabricSelect.selectedIndex = k;
          break;
        }
      }
      /* Con una sola tela el selector no aporta nada, pero igual se envía. */
      fabricPicker.hidden = telas.length < 2;
    };

    /* La paleta de color depende de la tela exacta elegida. Felpa y velvet
       comparten gama; una tela sin gama publicada muestra el aviso de
       consultar en vez de muestras inventadas. */
    var colorPicker = productForm.querySelector("[data-color-picker]");
    var paletas = null;
    var swatchBox, colorInput, colorLabel, colorCurrent, colorConsultar;

    if (colorPicker) {
      swatchBox = colorPicker.querySelector("[data-swatches]");
      colorInput = colorPicker.querySelector("[data-color-input]");
      colorLabel = colorPicker.querySelector("[data-color-label]");
      colorCurrent = colorPicker.querySelector("[data-color-current]");
      colorConsultar = colorPicker.querySelector("[data-color-consultar]");
      var paletasEl = colorPicker.querySelector("[data-color-palettes]");
      try {
        paletas = JSON.parse(paletasEl.textContent);
      } catch (e) {
        paletas = null;
      }
    }

    /* ---- Galería que sigue al color elegido ----
       Cada foto declara para qué color y tela es, en su texto alternativo:
         "Sofá Nantes 2 cuerpos | color: Azul | tela: Velvet"
       Se prefiere la foto que calce color Y tela; si no hay, la que calce solo
       el color. Sin coincidencia se deja la foto actual y se avisa, para que
       nadie crea que compra el color de la foto. */
    var fotoNota = document.querySelector("[data-foto-nota]");
    var galeriaMain = document.querySelector("[data-gallery-main]");
    var fotos = [];
    var fotosEl = document.querySelector("[data-fotos-color]");
    if (fotosEl) {
      try {
        fotos = JSON.parse(fotosEl.textContent);
      } catch (e) {
        fotos = [];
      }
    }

    var normalizar = function (s) {
      return String(s || "").toLowerCase()
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
    };

    var etiquetaDe = function (alt, campo) {
      var partes = String(alt || "").split("|");
      for (var i = 0; i < partes.length; i++) {
        var trozo = partes[i].trim();
        var sep = trozo.indexOf(":");
        if (sep === -1) continue;
        if (normalizar(trozo.slice(0, sep)) === campo) {
          return normalizar(trozo.slice(sep + 1));
        }
      }
      return "";
    };

    /* Una foto puede servir a varias medidas: "medida: 180 x 85, 220 x 85". */
    var medidaSelect = productForm.querySelector('[data-option-name="Medida"]');

    var listaDe = function (alt, campo) {
      var v = etiquetaDe(alt, campo);
      if (!v) return [];
      return v.split(",").map(function (x) { return x.trim(); })
              .filter(function (x) { return x; });
    };

    /* Mapa nombre-de-archivo -> medidas, definido en el tema. Manda sobre la
       etiqueta del alt porque Shopify no actualiza el alt de una imagen que ya
       estaba en el producto: reimportar el CSV corregido no la cambia. */
    var medidasArchivo = null;
    var mapaEl = document.querySelector("[data-medidas-archivo]");
    if (mapaEl) {
      try {
        medidasArchivo = JSON.parse(mapaEl.textContent);
      } catch (e) {
        medidasArchivo = null;
      }
    }
    /* De más largo a más corto: SOFA_NUBE_3C_L debe ganarle a SOFA_NUBE_3C. */
    var clavesArchivo = medidasArchivo
      ? Object.keys(medidasArchivo).sort(function (a, b) { return b.length - a.length; })
      : [];

    var medidasDeFoto = function (foto) {
      /* Nombre del archivo sin ruta, sin ?v= y sin extensión. */
      var nombre = String(foto.src).split("?")[0].split("/").pop();
      var raiz = nombre.replace(/\.[^.]+$/, "");

      for (var i = 0; i < clavesArchivo.length; i++) {
        var k = clavesArchivo[i];
        /* El corte tiene que caer en un guion bajo: si no,
           SOFA_NANTES_2C_LS_CAMEL14 calzaría con SOFA_NANTES_2C_L y las fotos
           de lino sintético se tomarían por la versión con chaise. */
        if (raiz !== k && raiz.indexOf(k + "_") !== 0) continue;
        var v = medidasArchivo[k];
        return v ? v.split(",").map(function (x) { return normalizar(x); })
                    .filter(function (x) { return x; })
                 : [];
      }
      return listaDe(foto.alt, "medida");
    };

    var syncGaleria = function (color) {
      if (!galeriaMain || !fotos.length) return;

      var tela = normalizar(fabricSelect ? fabricSelect.value : "");
      var medida = normalizar(medidaSelect ? medidaSelect.value : "");
      var col = normalizar(color);

      /* Puntaje: la medida define la configuración física (con chaise o sin
         ella), así que pesa más que el color, que además ya se ve en la
         muestra. color+medida = 3 es la foto exacta. */
      var elegida = null, mejor = 0, calzaColor = false, calzaMedida = false;

      for (var i = 0; i < fotos.length; i++) {
        var alt = fotos[i].alt;
        var ft = etiquetaDe(alt, "tela");
        if (ft && tela && ft !== tela) continue;   // foto de otra tela

        var okColor = etiquetaDe(alt, "color") === col && col !== "";
        var medidas = medidasDeFoto(fotos[i]);
        var okMedida = medidas.length > 0 && medidas.indexOf(medida) !== -1;

        var puntaje = (okMedida ? 2 : 0) + (okColor ? 1 : 0);
        if (puntaje > mejor) {
          mejor = puntaje;
          elegida = fotos[i];
          calzaColor = okColor;
          calzaMedida = okMedida;
        }
        if (mejor === 3) break;
      }

      if (!elegida) {
        if (fotoNota) {
          fotoNota.textContent =
            "Todavía no tenemos foto de este modelo en " + color +
            ". La imagen es referencial: el sofá se confecciona en la medida y " +
            "el color que elijas.";
          fotoNota.hidden = false;
        }
        return;
      }

      galeriaMain.src = elegida.src;
      var thumbs = document.querySelectorAll("[data-gallery-thumb]");
      for (var k = 0; k < thumbs.length; k++) {
        thumbs[k].classList.toggle(
          "is-active", thumbs[k].getAttribute("data-full") === elegida.src);
      }

      if (!fotoNota) return;
      /* Sin color elegido (tela sin carta) basta con que calce la medida. */
      if (calzaMedida && !col) {
        fotoNota.hidden = true;
      } else if (calzaColor && calzaMedida) {
        fotoNota.hidden = true;
      } else if (calzaMedida) {
        fotoNota.textContent =
          "La foto muestra la medida que elegiste, en otro color. " +
          "Lo confeccionamos en " + color + ".";
        fotoNota.hidden = false;
      } else {
        fotoNota.textContent =
          "La foto muestra el color que elegiste en otra configuración. " +
          "Las medidas serán las que seleccionaste: " + (medidaSelect ? medidaSelect.value : "") + " cm.";
        fotoNota.hidden = false;
      }
    };

    var pickColor = function (boton) {
      var botones = swatchBox.querySelectorAll("[data-color-swatch]");
      for (var i = 0; i < botones.length; i++) {
        var activo = botones[i] === boton;
        botones[i].classList.toggle("is-active", activo);
        botones[i].setAttribute("aria-checked", activo ? "true" : "false");
      }
      var nombre = boton.getAttribute("data-color");
      colorInput.value = nombre;
      colorLabel.textContent = nombre;
      syncGaleria(nombre);
    };

    var syncColors = function () {
      if (!colorPicker || !paletas) return;

      var tela = fabricSelect ? fabricSelect.value : "";
      var clave = paletas.porTela[tela];
      var gama = clave ? paletas.gamas[clave] : null;
      var previo = colorInput.value;

      swatchBox.innerHTML = "";

      if (!gama || !gama.length) {
        /* Tela sin carta publicada: no inventamos colores. */
        swatchBox.hidden = true;
        colorCurrent.hidden = true;
        colorConsultar.hidden = false;
        colorInput.value = "";
        /* Sin carta de colores igual hay que seguir la medida: el Nube con
           chaise solo se vende en boucle, y esa tela no tiene gama. */
        syncGaleria("");
        return;
      }

      swatchBox.hidden = false;
      colorCurrent.hidden = false;
      colorConsultar.hidden = true;

      var elegido = null;
      for (var i = 0; i < gama.length; i++) {
        var nombre = gama[i][0];
        var hex = gama[i][1];
        var b = document.createElement("button");
        b.type = "button";
        b.className = "pdp__swatch";
        b.setAttribute("data-color-swatch", "");
        b.setAttribute("data-color", nombre);
        b.setAttribute("role", "radio");
        b.setAttribute("aria-checked", "false");
        b.title = nombre;
        b.style.setProperty("--swatch", hex);
        b.innerHTML = '<span class="visually-hidden">' + nombre + "</span>";
        (function (boton) {
          boton.addEventListener("click", function () {
            pickColor(boton);
          });
        })(b);
        swatchBox.appendChild(b);
        /* Conserva el color elegido si sigue existiendo en la gama nueva. */
        if (nombre === previo) elegido = b;
      }
      pickColor(elegido || swatchBox.firstChild);
    };

    var update = function () {
      flagImpossible();
      syncFabrics();
      syncColors();
      var variant = findVariant(currentSelection());

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = "Combinación a cotizar";
        }
        if (unavailableMsg) unavailableMsg.hidden = false;
        return;
      }

      if (unavailableMsg) unavailableMsg.hidden = true;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? addButtonLabel : "Agotado";
      }

      if (priceNow) priceNow.textContent = variant.price_money;

      var onSale = variant.compare_at_price > variant.price;
      if (priceNow) priceNow.classList.toggle("pdp__price-now--sale", onSale);
      if (priceWas) {
        priceWas.hidden = !onSale;
        priceWas.textContent = variant.compare_money;
      }
      if (priceBadge) {
        priceBadge.hidden = !onSale;
        if (onSale) {
          var pct = Math.round(
            (variant.compare_at_price - variant.price) * 100 / variant.compare_at_price
          );
          priceBadge.textContent = "-" + pct + "%";
        }
      }

      /* Deja la URL compartible con la variante elegida. */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      }
    };

    for (var s = 0; s < selects.length; s++) {
      selects[s].addEventListener("change", update);
    }
    update();

    /* Cambiar de tela dentro del mismo nivel no toca el precio, pero sí la
       gama de colores. */
    if (fabricSelect) fabricSelect.addEventListener("change", syncColors);
  }
})();
